export const FETCH_CERTIFICATES_REQUEST = 'FETCH_CERTIFICATES_REQUEST';
export const FETCH_CERTIFICATES_SUCCESS = 'FETCH_CERTIFICATES_SUCCESS';
export const FETCH_CERTIFICATES_FAILURE = 'FETCH_CERTIFICATES_FAILURE';
